module.exports = __webpack_public_path__ + "img/JAOC_POP_CheddarCheese_rectangular.ce7a96ec.png";